module.exports = __webpack_public_path__ + "img/微型电子锁 (5).2749f81b.jpg";